import { UpdatableObjectState, UpdatableObjectFilterState } from "./types";
import * as actions from "./updatableObjectsActions";

const initialFilterState: UpdatableObjectFilterState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.UPDATABLE_OBJECTS_GET_REQUEST]: (state, action) => ({
    ...state,
    [action.filterType]: {
      ...state[action.filterType],
      loading: true,
      loaded: false,
      error: null,
    },
  }),
  [actions.UPDATABLE_OBJECTS_GET_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    [action.filterType]: {
      ...state[action.filterType],
      loading: false,
      loaded: true,
      error: null,
      data: action.data,
    },
  }),
  [actions.UPDATABLE_OBJECTS_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    [action.filterType]: {
      ...state[action.filterType],
      loading: false,
      loaded: false,
      error: action.error,
      data: null,
    },
  })
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState: UpdatableObjectState = {
  splitTunneling: { ...initialFilterState },
  internetAccess: { ...initialFilterState },
};

export default function usersMeGetReducer(state = initialState, action): UpdatableObjectState {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
